import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import plusIconfile from "../../../assets/icons/attach-ticket.svg";
import excelIcon from "../../../assets/icons/excel2-svgrepo-com.svg";
import pdfIcon from "../../../assets/icons/pdf-file-svgrepo-com.svg";
import chatsendicon from "../../../assets/icons/send-ticket.svg";
import supporetrIcon from "../../../assets/icons/supporterIcon.svg";
import wordIcon from "../../../assets/icons/word2-svgrepo-com.svg";
import crossdelete from "../../../assets/images/crossdelete.svg";
import useFileUpload from "../../../hooks/useFileUpload";
import { api } from "../../../utils/axios/Config";
import { getImage, handleErrorApi, unixToPersianDay, unixToPersianTime } from "../../../utils/utils";
import BackButton from "../../shared/BackButton";
import ImageContainer from "../../shared/ImageContainer";
import Loader from "../../shared/Loader";
import ShowMoreText from "../../shared/show-more";
import AutoHeightTextarea from "../../ui/AutoSizeTextArea";

const MAX_FILE_SIZE = 1000 * 1024 * 1024; // 1gb

const MobileChatPage = () => {
  const [attachLoading, setAttachLoading] = useState(false);
  const [ticketMessage, setTicketMessage] = useState([]);
  const [message, setMessage] = useState("");
  const [ticketStatus, setTicketStatus] = useState({});
  const [attachment, setAttachment] = useState([]);
  const params = useParams();
  const lastMessageRef = useRef();
  const { uploadFile } = useFileUpload();

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles[0].size > MAX_FILE_SIZE) {
      toast.error("حجم فایل زیاد است");
      return;
    }
    handleAttachment(acceptedFiles);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "image/*": [".png", ".jpeg", ".jpg", ".webp"],
      "application/pdf": [".pdf"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx", ".xls", ".csv"],
      "application/msword": [".doc", ".docx"],
    },
  });

  const handleDeletePic = () => setAttachment([]);

  const ticketInfo = async () => {
    try {
      const response = await api.get(`/tickets/message/${params.id}/`);
      setTicketMessage(response.data.items);
      setTicketStatus(response.data.items[0].ticket);
    } catch (error) {
      handleErrorApi(error);
    }
  };

  useEffect(() => {
    ticketInfo();
  }, [params?.id]);

  const sendNewTicket = async (e) => {
    e.preventDefault();
    if (message.length > 5000) {
      toast.error("تعداد کاراکتر مجاز پیام 5000 کاراکتر است");
      return;
    }
    const attachmentsArray = [];
    attachment.forEach((item) => attachmentsArray.push(item.url));

    if (message || attachment.length > 0) {
      try {
        const res = await api.post(`/tickets/message/${params.id}/`, {
          text: message,
          attachments: attachmentsArray,
          reply_to: null,
        });
        if (res.status === 201) {
          setMessage("");
          ticketInfo();
          handleDeletePic();
        }
      } catch (error) {
        handleErrorApi(error);
      }
    }
  };

  const handleAttachment = async (files) => {
    setAttachLoading(true);
    let fuleUrls = [];
    try {
      const uploadPromises = files.map(async (file) => {
        try {
          const res = await uploadFile({ file, pic_type: "Ticket" });

          if (res?.status === 200) {
            const { url, preview_url } = res.data;
            fuleUrls.push({ url, preview_url });

            return res;
          } else {
            console.error("Upload failed for file:", file.name);
            fuleUrls.push("url");
          }
        } catch (err) {
          console.error("Error uploading file:", file.name, err);
          setAttachment([]);
          throw err;
        }
      });

      await Promise.all(uploadPromises);
    } catch (err) {
      console.error("Error during file upload process:", err);
    } finally {
      // setFileIsUploading(false);
      setAttachment(fuleUrls);
      setAttachLoading(false);
    }
  };

const renderAttachmentPreview = (file) => {
    if (!file) return null;

    let icon = null;
    if (file.includes("xlsx") || file.includes("xls") || file.includes("csv")) icon = excelIcon;
    if (file.includes("docs") || file.includes("doc")) icon = wordIcon;
    if (file.includes("pdf")) icon = pdfIcon;

    const fileName = file.split("/").pop() || file;

    return (
      <div className="flex items-center w-fit max-w-[220px] rounded-v-md border border-neutral-30 bg-white p-2 shadow-sm">
        {icon ? (
          <a
            href={import.meta.env.VITE_STORAGE_ENDPOINT + file}
            download
            title={fileName}
            className="flex items-center gap-2 min-w-0 hover:opacity-80 transition-opacity"
          >
            <img src={icon} alt="" className="w-9 h-9 shrink-0 object-contain" />
            <span className="truncate text-xs text-neutral-70 text-start">{fileName}</span>
          </a>
        ) : (
          <div className="overflow-hidden rounded-v-sm">
            <ImageContainer src={getImage(file)} width="64px" height="64px" />
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="w-screen h-screen  flex flex-col    bg-white   relative   ">
      <div className="p-4  border-b-2 sticky top-0 bg-white shadow-md flex justify-between items-center rounded-t-md">
        <div className="flex gap-1">
          <p>موضوع تیکت:</p>
          <span className="font-bold">{ticketStatus.title}</span>
        </div>
        <BackButton />
      </div>

      <div className="overflow-y-scroll vanda h-full w-full  pb-[200px] bg-neutral-20   ">
        <ul className="flex flex-col-reverse  gap-6 p-2 md:p-6">
          {ticketMessage.map((items, index) => {
            const isAdmin = items?.message?.as_admin_response;
            return (
              <li
                key={index}
                className={`w-fit flex flex-col min-w-[70vw] text-dark  max-w-[90vw]  ${
                  isAdmin ? "mr-auto " : ""
                } rounded-v-lg`}
              >
                {isAdmin && (
                  <div className="flex gap-1 text-[12px]  text-dark w-fit mr-auto ">
                    <img alt="supporter icon" width={12} height={12} src={supporetrIcon} />
                    <p className="">پشتیبان</p>
                  </div>
                )}

                <div
                  className={`w-full flex flex-col p-1 overflow-scroll  ${
                    isAdmin ? "mr-auto bg-[#39A78E]" : "bg-[#9C9CA3]"
                  } rounded-v-lg`}
                >
                  <ShowMoreText
                    lines={3}
                    more="..."
                    less="..."
                    className="text-[#F0F0F7]  rounded-md break-words p-2 flex-1 "
                    anchorClass="text-dark cursor-pointer text-[10px] "
                    expanded={false}
                    width={0}
                    truncatedEndingComponent={"... "}
                  >
                    {items.message.text || ""}
                  </ShowMoreText>

                  <div className="flex text-[#F0F0F7]  text-opacity-75  gap-2">
                    {items.attachments.length > 0 &&
                      items.attachments.map((item) => {
                        return renderAttachmentPreview(item.url_preview);
                      })}
                  </div>
                  <div className="flex gap-1 items-center text-neutral-10 text-[12px] justify-end pt-2  w-fit mr-auto px-2">
                    <p>{unixToPersianDay(items.message.creation_time)}</p> -
                    <p>{unixToPersianTime(items.message.creation_time)}</p>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
        <div ref={lastMessageRef}></div>
      </div>

      <div className="w-full bg-white p-2 md:p-2 rounded-b-md   px-3 fixed bottom-0 ">
        {(attachLoading || attachment.length > 0) && (
          <div className="w-full h-fit  px-2 pt-1 bg-neutral-20 rounded-t-lg flex justify-between items-center  py-4">
            {attachLoading ? (
              <Loader />
            ) : (
              <div className="flex flex-col flex-center bg-dark-3 rounded-xl cursor-pointer gap-2">
                <div className="flex gap-2">
                  {attachment.length > 0 &&
                    attachment.map((item) => {
                      console.log(item, "item");
                      return renderAttachmentPreview(item.preview_url);
                    })}
                </div>
              </div>
            )}
            <img
              onClick={handleDeletePic}
              className="cursor-pointer w-10 h-10"
              src={crossdelete}
              alt="delete"
            />
          </div>
        )}
        <div className="flex w-full items-center justify-between gap-2  border-[#e7e9ec] p-3  ">
          <div className="cursor-pointer" {...getRootProps()}>
            <input {...getInputProps()} />
            <img src={plusIconfile} alt="attach-file" />
          </div>
          <AutoHeightTextarea setMessage={setMessage} value={message} />

          <button
            onClick={sendNewTicket}
            disabled={!(message || attachment)}
            className="disabled:opacity-50 cursor-pointer hover:scale-105"
          >
            <img src={chatsendicon} alt="send" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileChatPage;
